
export const Paths = {
  // Management routes
  ManagementLogin: '/management/login',
  ManagementDashboard: '/app/management',
  PublicLogin: '/login',
  PublicDashboard: '/home',
  Home: '/home',

  Management: {
    root: '/app',
    Dashboard: '/app/management/dashboard',
    Clients: '/app/management/clientes',
    NewClient: '/app/management/clientes/nuevo',
    Contracts: '/app/management/contrataciones',
    NewContract: '/app/management/contrataciones/nuevo',
    Cremations: '/app/management/cremaciones',
    Subscriptions: '/app/management/abonos',
    PaymentPlans: '/app/management/planes-pago',
    Parcels: '/app/management/parcelas',
    ParcelsSell: '/app/management/parcelas/vender',
    Offerings: '/app/management/servicios',
    NewOffering: '/app/management/servicios/nuevo',
    EditOffering: '/app/management/servicios/modificar',
    NewOfferingPrice: '/app/management/servicios/$offeringId/precios/nuevo',
    Users: '/app/management/usuarios',
    Settings: '/app/management/configuracion',
    CashBox: '/app/management/caja',
    CashBoxMovements: '/app/management/caja/$userId',
    Accounts: '/app/management/cuentas',
    MainAccounts: '/app/management/cuentas/principales',
    CollectorAccounts: '/app/management/cuentas/cobradores',
    AccountDetails: '/app/management/cuentas/$accountId',
    Collectors: '/app/management/cobradores',
    Sales: '/app/management/ventas',
    SellerSales: '/app/management/ventas/vendedor/$sellerId',
    OfferingSales: '/app/management/ventas/servicio/$offeringId',
    Invoicing: '/app/management/facturacion',
    InvoiceGenerationStatus: '/app/management/facturacion/generacion',
    EditInvoiceItems: '/app/management/facturacion/editar',
    CollectorInvoices: '/app/management/cobradores-facturados',

    Payments: 'pagos',
    MultiPayments: '/app/management/multi-pagos',
    PaymentInvoices: '/app/management/pagos-facturados',
    SubscriptionPeriodPayments: '/app/management/subscripciones/periodo/',
    SubscriptionPayments: '/app/management/subscripciones',
    ParcelContract: '/app/management/contrataciones/$contractId/parcela/$parcelId',
    OccupyingParcel: '/app/management/contrataciones/$contractId/parcela/$parcelId/ocupar',
    AddingAdditionalParcel: '/app/management/contrataciones/$contractId/parcela/$parcelId/adicionales',
    CompleteRedemption: '/app/management/contrataciones/$contractId/redencion/$redemptionId',
    Reports: '/app/management/reportes',
  }

} as const


export const getRelativePath = (route: string) => {
  return route.replace('/app', '')
}

export type PathKeys = keyof typeof Paths
export type PathValues = typeof Paths[PathKeys]
